import { Link } from 'react-router-dom';
import { getSolutionUrl } from '../../../utils/routerUrls';

export const formatLink = (
  orgzId: string,
  examinerId: string,
  processTypeId: string,
  deskId: string,
  deskExaminerFunction: string,
): JSX.Element => {
  return (
    <Link tabIndex={-1} to={getSolutionUrl(orgzId, examinerId, processTypeId, deskId, deskExaminerFunction)}>
      {orgzId}
    </Link>
  );
};
